(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );


  // Support hover, click, and keyboard activation for desktop mega menus.
  if (!window.__dawnMegaMenuHoverBound) {
    window.__dawnMegaMenuHoverBound = true;
    const dawnMegaDesktopMedia = window.matchMedia('(min-width: 990px)');

    const closeOtherMegaMenus = (currentDetails) => {
      document.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
        if (details === currentDetails) return;
        details.dataset.clickOpen = 'false';
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
    };

    const bindDawnMegaMenuHover = () => {
      document.querySelectorAll('header-menu details.mega-menu').forEach((details) => {
        if (details.dataset.hoverBound === 'true') return;

        const summary = details.querySelector('summary');
        const content = details.querySelector('.mega-menu__content');
        if (!summary || !content) return;

        let closeTimer;

        const setMenuTop = () => {
          const header = details.closest('.section-header')?.querySelector('.header-wrapper, header') || details.closest('header');
          const headerBottom = header?.getBoundingClientRect().bottom ?? summary.getBoundingClientRect().bottom;
          content.style.setProperty('--mega-menu-top', Math.max(0, Math.round(headerBottom)) + 'px');
        };

        const setExpanded = (expanded) => {
          if (expanded) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
          summary.setAttribute('aria-expanded', String(expanded));
        };

        const openMenu = (persistent = false) => {
          if (!dawnMegaDesktopMedia.matches) return;
          window.clearTimeout(closeTimer);
          setMenuTop();
          if (persistent) details.dataset.clickOpen = 'true';
          setExpanded(true);
        };

        const closeMenu = (force = false) => {
          if (!dawnMegaDesktopMedia.matches) return;
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => {
            if (!force && (details.dataset.clickOpen === 'true' || details.matches(':hover') || details.contains(document.activeElement))) return;
            details.dataset.clickOpen = 'false';
            setExpanded(false);
          }, force ? 0 : 90);
        };

        const togglePersistentMenu = () => {
          if (details.dataset.clickOpen === 'true') {
            closeMenu(true);
            return;
          }
          closeOtherMegaMenus(details);
          openMenu(true);
        };

        details.addEventListener('pointerenter', () => openMenu(false));
        details.addEventListener('pointerleave', () => closeMenu(false));

        summary.addEventListener('click', (event) => {
          if (!dawnMegaDesktopMedia.matches) return;
          event.preventDefault();
          togglePersistentMenu();
          queueMicrotask(() => summary.setAttribute('aria-expanded', String(details.open)));
        });

        details.addEventListener('focusout', (event) => {
          if (!details.contains(event.relatedTarget)) closeMenu(true);
        });

        details.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeMenu(true);
          summary.focus();
        });

        document.addEventListener('click', (event) => {
          if (!dawnMegaDesktopMedia.matches || details.contains(event.target)) return;
          closeMenu(true);
        });

        window.addEventListener('resize', () => {
          if (details.open && dawnMegaDesktopMedia.matches) setMenuTop();
        });

        details.dataset.hoverBound = 'true';
      });
    };

    dawnMegaDesktopMedia.addEventListener('change', () => {
      if (!dawnMegaDesktopMedia.matches) {
        document.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
          details.dataset.clickOpen = 'false';
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      }
      bindDawnMegaMenuHover();
    });

    bindDawnMegaMenuHover();
    document.addEventListener('shopify:section:load', bindDawnMegaMenuHover);
    document.addEventListener('shopify:section:reorder', bindDawnMegaMenuHover);
    window.addEventListener('resize', bindDawnMegaMenuHover);
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-mobile-menu-close]');
    if (!closeButton) return;

    const drawer = closeButton.closest('header-drawer');
    const details = drawer?.querySelector('#Details-menu-drawer-container');
    const summary = details?.querySelector('summary');

    if (drawer && details && summary && typeof drawer.closeMenuDrawer === 'function') {
      summary.setAttribute('aria-expanded', 'false');
      drawer.closeMenuDrawer(event, summary);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikaslandi-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!window.IkaslandiBestSellers) {
    window.IkaslandiBestSellers = class {
      constructor(root) {
        this.root = root;
        this.viewport = root.querySelector('[data-viewport]');
        this.track = root.querySelector('[data-track]');
        this.cards = [...root.querySelectorAll('[data-card]')];
        this.previous = root.querySelector('[data-previous]');
        this.next = root.querySelector('[data-next]');
        this.progress = root.querySelector('[data-progress]');
        this.step = Number(root.dataset.step) || 1;

        if (!this.viewport || !this.cards.length) return;

        this.moveBy = (direction) => {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          this.viewport.scrollBy({
            left: (this.cards[0].getBoundingClientRect().width + gap) * this.step * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        this.update = () => {
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const scrollProgress = maxScroll > 0 ? Math.min(1, Math.max(0, this.viewport.scrollLeft / maxScroll)) : 0;

          if (this.previous) this.previous.disabled = this.viewport.scrollLeft <= 1;
          if (this.next) this.next.disabled = this.viewport.scrollLeft >= maxScroll - 1;
          this.progress?.style.setProperty('--bs-scroll-progress', scrollProgress);
        };

        this.previous?.addEventListener('click', () => this.moveBy(-1));
        this.next?.addEventListener('click', () => this.moveBy(1));
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        new ResizeObserver(this.update).observe(this.viewport);
        this.update();
      }
    };
  }

  const initializeBestSellers = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.bestSellersController = new window.IkaslandiBestSellers(root);
  };

  document.querySelectorAll('[data-best-sellers]').forEach(initializeBestSellers);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-best-sellers]').forEach(initializeBestSellers);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikaslandi-commitment"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-commitment-section]';

    const initialize = (root) => {
      if (!root || root.dataset.commitmentReady === 'true') return;

      const track = root.querySelector('[data-commitment-track]');
      const slides = Array.from(root.querySelectorAll('[data-commitment-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-commitment-dot]'));

      if (!track || slides.length === 0) return;

      const setActiveDot = (activeIndex) => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const getNearestSlideIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let nearestIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - trackCenter);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      let frameRequested = false;
      track.addEventListener('scroll', () => {
        if (frameRequested) return;
        frameRequested = true;

        window.requestAnimationFrame(() => {
          setActiveDot(getNearestSlideIndex());
          frameRequested = false;
        });
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slide = slides[index];
          if (!slide) return;

          track.scrollTo({
            left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
          setActiveDot(index);
        });
      });

      root.dataset.commitmentReady = 'true';
      setActiveDot(getNearestSlideIndex());
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikaslandi-design-concept"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-design-concept-section]';

    const initialize = (root) => {
      if (!root || root.dataset.designConceptReady === 'true') return;

      const track = root.querySelector('[data-design-concept-track]');
      const slides = Array.from(root.querySelectorAll('[data-design-concept-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-design-concept-dot]'));

      if (!track || slides.length === 0) return;

      const setActiveDot = (activeIndex) => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const getNearestSlideIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let nearestIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - trackCenter);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      let frameRequested = false;
      track.addEventListener('scroll', () => {
        if (frameRequested) return;
        frameRequested = true;

        window.requestAnimationFrame(() => {
          setActiveDot(getNearestSlideIndex());
          frameRequested = false;
        });
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slide = slides[index];
          if (!slide) return;

          const targetLeft = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
          track.scrollTo({
            left: targetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
          setActiveDot(index);
        });
      });

      root.dataset.designConceptReady = 'true';
      setActiveDot(getNearestSlideIndex());
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikaslandi-shop-by-category"] && !Shopify.designMode) return;
  try {
    
  window.IkaslandiCategory = window.IkaslandiCategory || class {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-category-viewport]');
      this.track = root.querySelector('[data-category-track]');
      this.cards = Array.from(root.querySelectorAll('[data-category-card]'));
      this.previous = root.querySelector('[data-category-previous]');
      this.next = root.querySelector('[data-category-next]');
      this.dots = Array.from(root.querySelectorAll('[data-category-dot]'));
      this.step = Number(root.dataset.slidesPerMove) || 1;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.cards.length) return;

      this.handleScroll = () => {
        this.updateActiveDot();
        this.updateControls();
      };
      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToIndex(Number(dot.dataset.slideIndex)));
      });
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.handleScroll);
      this.resizeObserver.observe(this.viewport);
      this.handleScroll();
    }

    cardStep() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return this.cards[0].getBoundingClientRect().width + gap;
    }

    move(direction) {
      this.viewport.scrollBy({
        left: this.cardStep() * this.step * direction,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    scrollToIndex(index) {
      this.viewport.scrollTo({
        left: this.cardStep() * index,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const atStart = this.viewport.scrollLeft <= 1;
      const atEnd = this.viewport.scrollLeft >= maxScroll - 1;
      if (this.previous) {
        this.previous.disabled = atStart;
        this.previous.setAttribute('aria-disabled', String(atStart));
      }
      if (this.next) {
        this.next.disabled = atEnd;
        this.next.setAttribute('aria-disabled', String(atEnd));
      }
    }

    updateActiveDot() {
      if (!this.dots.length) return;
      const index = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.viewport.scrollLeft / this.cardStep())));
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }
  };

  window.initializeIkaslandiCategory = window.initializeIkaslandiCategory || ((root) => {
    if (root.dataset.categoryInitialized === 'true') return;
    root.dataset.categoryInitialized = 'true';
    root.categoryController = new window.IkaslandiCategory(root);
  });

  document.querySelectorAll('[data-shop-by-category]').forEach(window.initializeIkaslandiCategory);
  if (!window.ikaslandiCategoryEditorListener) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-shop-by-category]').forEach(window.initializeIkaslandiCategory);
    });
    window.ikaslandiCategoryEditorListener = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!window.IkaslandiRelatedProductsCarousel) {
    window.IkaslandiRelatedProductsCarousel = class {
      constructor(root) {
        this.root = root;
        this.viewport = root.querySelector('[data-related-viewport]');
        this.track = root.querySelector('[data-related-track]');
        this.cards = [...root.querySelectorAll('[data-best-sellers-card]')];
        this.previous = root.querySelector('[data-related-previous]');
        this.next = root.querySelector('[data-related-next]');
        this.progress = root.querySelector('[data-related-progress]');

        if (!this.viewport || !this.cards.length) return;

        this.moveBy = (direction) => {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          this.viewport.scrollBy({
            left: (this.cards[0].getBoundingClientRect().width + gap) * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        this.update = () => {
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const scrollProgress = maxScroll > 0 ? Math.min(1, Math.max(0, this.viewport.scrollLeft / maxScroll)) : 0;

          if (this.previous) this.previous.disabled = this.viewport.scrollLeft <= 1;
          if (this.next) this.next.disabled = this.viewport.scrollLeft >= maxScroll - 1;
          if (this.progress) this.progress.style.setProperty('--related-scroll-progress', scrollProgress);
        };

        if (this.previous) this.previous.addEventListener('click', () => this.moveBy(-1));
        if (this.next) this.next.addEventListener('click', () => this.moveBy(1));
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        new ResizeObserver(this.update).observe(this.viewport);
        this.update();
      }
    };
  }

  const initializeRelatedProducts = (root) => {
    if (root.dataset.relatedProductsInitialized || !root.querySelector('[data-related-viewport]')) return;
    root.dataset.relatedProductsInitialized = 'true';
    root.relatedProductsController = new window.IkaslandiRelatedProductsCarousel(root);
  };

  const observeRelatedProducts = (root) => {
    if (root.dataset.relatedProductsObserved) return;
    root.dataset.relatedProductsObserved = 'true';
    initializeRelatedProducts(root);

    const observer = new MutationObserver(() => initializeRelatedProducts(root));
    observer.observe(root, { childList: true, subtree: true });
    root.relatedProductsObserver = observer;
  };

  document.querySelectorAll('[data-related-products-carousel]').forEach(observeRelatedProducts);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-related-products-carousel]').forEach(observeRelatedProducts);
  });

  } catch(e) { console.error(e); }
})();
})();
